import React, { useState } from 'react';
import styles from './styles';

const ToolsList = ({ post }) => {
  const [openList, setOpenList] = useState(false);

  const handleOpenList = () => {
    setOpenList(!openList);
  };

  return (
    <>
      <div className="content-tools">
        <div
          className={'tool tools-title' + (!openList ? ' bordered' : '')}
          onClick={handleOpenList}
        >
          <div className="tool-title">
            <img draggable="false" src="/icons/Vector.png" alt="icon" />
            <span>Required Tools</span>
          </div>
          <img
            draggable="false"
            src="/icons/fluent_ios-arrow-24-filled.png"
            alt="icon"
            className={'arrow' + (openList ? ' rotate-arrow' : '')}
          />
        </div>
        <div className={'tools-list' + (openList ? ' openned' : '')}>
          {post.data.tools_needed.map((tool) => (
            <div className="tool" key={tool.text}>
              <img draggable="false" src="/icons/Vector.png" alt="icon" />
              <span>{tool.text}</span>
            </div>
          ))}
        </div>
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default ToolsList;
